import { render } from "./TelesecretaryWidget.vue?vue&type=template&id=4028781a&ts=true"
import script from "./TelesecretaryWidget.vue?vue&type=script&lang=ts"
export * from "./TelesecretaryWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__